import { z } from 'zod'

export const GetBillCategorySchema = z.object({
  alias: z.string(),
  title: z.string(),
})
